export const contractStatusLabel = {
  0: '@insurance/createdStatusLabel',
  1: '@insurance/offerAcceptedStatusLabel',
  3: '@insurance/toBeTerminatedStatusLabel',
  4: '@insurance/terminatedStatusLabel',
  5: '@insurance/terminatingStatusLabel',
  6: '@insurance/unpaidPaperInvoiceStatusLabel',
};

// Bug in backend part, need to rewrite one of variants
export const ContractStatusEnum = {
  created: 0,
  offerAccepted: 1,
  toBeTerminated: 3,
  terminated: 4,
  terminating: 5,
  unpaidPaperInvoice: 6,
  0: 'created',
  1: 'offerAccepted',
  3: 'toBeTerminated',
  4: 'terminated',
  5: 'terminating',
  6: 'unpaidPaperInvoice',
};

export const BankDetailsStatusEnum = {
  new: 1,
  pending: 2,
  approved: 3,
  declined: 4,
  cancelling: 5,
  absent: 6,
};

export const bankDetailsStatus = {
  1: '@insurance/bankDetails/newStatusLabel',
  2: '@insurance/bankDetails/pendingStatusLabel',
  3: '@insurance/bankDetails/approvedStatusLabel',
  4: '@insurance/bankDetails/declinedStatusLabel',
  5: '@insurance/bankDetails/cancellingStatusLabel',
  6: '@insurance/bankDetails/absentStatusLabel',
};

const MandateInformationCode = {
  payeeCancellation: '03',
  newAddition: '04',
  payerNumberChanged: '05',
  payeeBankgiroNumberClosed: '10',
  accountInquiryAnswered: '42',
  accountInquiryUnanswered: '43',
  payerBankgiroNumberClosed: '44',
  payerCancellation: '46',
  recordsAlreadyCancelledDateAmended: '47',
};

const MandateCommentCode = {
  mandateCancelled: '02',
  accountTypeNotApproved: '03',
  mandateNotFound: '04',
  incorrectBankDetails: '05',
  unansweredAccountInquiry: '07',
  bankgiroNumberNotFound: '09',
  mandateAlreadyRegistered: '10',
  incorrectCivicNumber: '20',
  incorrectPayerNumber: '21',
  incorrectAccountNumber: '23',
  incorrectBankgiroNumber: '29',
  noBankgiroNumber: '30',
  newMandate: '32',
  cancelled: '33',
  payerNumberCancelled: '98',
};

// export const WinbackTypes = {
//   expensive: '@winbackForm/expensive',
//   hasIncomeInsurance: '@winbackForm/hasIncomeInsurance',
//   hasLoanProtection: '@winbackForm/hasLoanProtection',
//   doubleWithdrawal: '@winbackForm/doubleWithdrawal',
//   poorNoFeedback: '@winbackForm/poorNoFeedback',
//   insufficientInfo: '@winbackForm/insufficientInfo',
//   noNeed: '@winbackForm/noNeed',
//   noLoan: '@winbackForm/noLoan',
//   other: '@winbackForm/other',
// };

export const WinbackTypes = {
  byPhone: '@winbackForm/byPhone',
  wrongBankDetails: '@winbackForm/wrongBankDetails',
  missingBankDetails: '@winbackForm/missingBankDetails',
  unpaidInvoice: '@winbackForm/unpaidInvoice',
};

export function getMandateInformationCode(code) {
  switch (code) {
    case MandateInformationCode.payeeCancellation:
      return 'Makulering. Initierat av betalningsmottagaren.';
    case MandateInformationCode.newAddition:
      return 'Nyupplägg. Initierat av betalningsmottagaren';
    case MandateInformationCode.payerNumberChanged:
      return 'Byte av betalarnummer. Endast tillåtet för Medgivanden med bankkontonummer. Initierat av betalningsmottagaren.';
    case MandateInformationCode.payeeBankgiroNumberClosed:
      return 'Makulerat på grund av att betalningsmottagarens bankgironummer är avslutat. Initierat av betalningsmottagaren själv eller via dennes bank.';
    case MandateInformationCode.accountInquiryAnswered:
      return 'Svar på kontoförfrågan från bank på ny betalare i Autogiro.';
    case MandateInformationCode.accountInquiryUnanswered:
      return 'Makulerat/borttaget på grund av obesvarad kontoförfrågan.';
    case MandateInformationCode.payerBankgiroNumberClosed:
      return 'Makulerat på grund av att betalarens bankgironummer är avslutat. Initierat av betalarens bank.';
    case MandateInformationCode.payerCancellation:
      return 'Makulering. Initierat av betalaren eller betalarens bank';
    case MandateInformationCode.recordsAlreadyCancelledDateAmended:
      return 'Makulering som redan har avbrutits eller datum ändrats';
    default:
      return `${code} (unknown code)`;
  }
}

export function getMandateCommentCode(code) {
  switch (code) {
    case MandateCommentCode.mandateCancelled:
      return 'Medgivandet är makulerat på initiativ av betalaren eller betalarens bank.';
    case MandateCommentCode.accountTypeNotApproved:
      return 'Kontoslaget är inte godkänt för Autogiro.';
    case MandateCommentCode.mandateNotFound:
      return 'Medgivandet saknas i Bankgirots Medgivanderegister.';
    case MandateCommentCode.incorrectBankDetails:
      return 'Felaktiga bankkonto- eller personuppgifter';
    case MandateCommentCode.unansweredAccountInquiry:
      return 'Makulerat/borttaget på grund av obesvarad kontoförfrågan.';
    case MandateCommentCode.bankgiroNumberNotFound:
      return 'Betalarbankgironumret saknas hos Bankgirot.';
    case MandateCommentCode.mandateAlreadyRegistered:
      return 'Medgivandet finns redan upplagt i Bankgirots register eller är under förfrågan.';
    case MandateCommentCode.incorrectCivicNumber:
      return 'Felaktigt person-/organisationsnummer eller avtal om medgivande med bankgironummer saknas.';
    case MandateCommentCode.incorrectPayerNumber:
      return 'Felaktigt betalarnummer.';
    case MandateCommentCode.incorrectAccountNumber:
      return 'Felaktigt bankkontonummer.';
    case MandateCommentCode.incorrectBankgiroNumber:
      return 'Mottagarbankgironummer är felaktigt';
    case MandateCommentCode.noBankgiroNumber:
      return 'Mottagarbankgironummer är avregistrerat.';
    case MandateCommentCode.newMandate:
      return 'Nytt Medgivande.';
    case MandateCommentCode.cancelled:
      return 'Makulerad.';
    case MandateCommentCode.payerNumberCancelled:
      return 'Medgivandet är makulerat på grund av makulerat betalarbankgironummer.';
    default:
      return `${code} (unknown code)`;
  }
}
